/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'truncate' } )
export class TruncatePipe implements PipeTransform {
    
    transform( pString: string, pLimit = 25, pCompleteWords = false, pEllipsis = '...' ): string {
        if ( pString && pString.length > pLimit ) {
            if ( pCompleteWords ) {
                pLimit = pString.substr( 0, pLimit ).lastIndexOf( ' ' );
            }
            return `${pString.substr( 0, pLimit )}${pEllipsis}`;
        }
        return pString;
    }
}
